module.exports = __webpack_public_path__ + "static/media/website-07.15268956.png";